import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Button, Card, Col, Form, Input, Row, Select } from 'antd';

import { customerApiEndpoints, subscribeApiEndpoints } from '@/api/endpoints';
import { optionSearchFunction } from '@/utils/common';

import { handleUpdatePostApi } from '@/api/crud';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
import { rules } from '@/utils/validation/FormValidation';
import { useFetch } from '@/hooks';

const SuperAdminUserEdit = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const controller = new AbortController();

  useEffect(() => {
    const signal = controller.signal;
    async function handleCompanyDetailsOnLoad() {
      try {
        const res = await customerApiEndpoints.superAdminRetrieve(id, signal);

        if (res.data.data) {
          const customer = res.data.data;
          if (customer) {
            form.setFieldsValue(customer);
          }
        }
      } catch (error) {
        throw new Error(error);
      }
    }

    handleCompanyDetailsOnLoad();

    //  clear up function
    return () => {
      controller.abort();
    };
  }, [id]);

  const navigateToList = () => navigate('/admin/user/list/');

  return (
    <>
      <Card>
        <Form
          form={form}
          className="username"
          onFinish={(value) => {
            handleUpdatePostApi(
              id,
              customerApiEndpoints.superAdminUpdate,
              {
                ...value,
              },
              setLoading,
              form,
              navigateToList,
            );
          }}
          layout="vertical"
        >
          <LoadingOverlay spinning={loading} />
          <GlobalDivider name="Edit User" />
          <Row gutter={24}>
            {/*<Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="Subscription ID"
                name="subscriptionId"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Select
                  showSearch
                  placeholder="Select Subscription"
                  filterOption={(value, option) =>
                    optionSearchFunction(value, option)
                  }
                  options={subscriptionData?.map((item) => {
                    return {
                      label: item.subscriptionId,
                      value: item.referenceId,
                  };
                  })}
                />
              </Form.Item>
            </Col>*/}

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="Username"
                name="username"
                rules={rules.required}
                hasFeedback
                validateTrigger="onChange"
              >
                <Input placeholder="Username" />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item label="Email" name="email" className="font-bold">
                <Input placeholder="example@domin.com" autoComplete="off" />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="Mobile"
                className="font-bold"
                name="mobileNumber"
                rules={rules.phoneNumber}
                validateTrigger="onChange"
              >
                <Input type="tel" placeholder="98XXXXXXX" maxLength={10} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                label="First Name"
                name="firstName"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Input placeholder="First Name" />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                className="font-bold"
                label="Last Name"
                name="lastName"
                rules={rules.required}
                validateTrigger="onChange"
              >
                <Input placeholder="Last Name" />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item label="Address" name="address" className="font-bold">
                <Input placeholder="Address" autoComplete="off" />
              </Form.Item>
            </Col>
          </Row>

          <div className="flex justify-end">
            <div className="flex gap-2">
              <Button type="primary" htmlType="submit">
                Update
              </Button>
              <Button className="auto-danger-btn" onClick={() => navigate(-1)}>
                Back
              </Button>
            </div>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default SuperAdminUserEdit;
